import React from 'react';

export default function IntroSection(){
  return  <section id="intro-section">
  <h1>What makes it <span>interesting</span>?</h1>
  <div className="intro">
    <div className="intro-text">
      <p>
      The appearance of Golden ratio is can be found through out the nature: face, body, flower petals, animals, fibonacci series, shell, galaxies, arts, architecture etc. In the world of mathematics, the number has great significance as well as some interesting properties. Alot of world's great Paintings and big company logos were even inspired by this ratio.
      </p>
    </div>
    <div className="intro-img">
      <img alt="intro-img" src ={process.env.PUBLIC_URL + '/intro.jpg'}></img>
    </div>
  </div>
</section>
}